import React, { useMemo, useState } from "react";
import { useAxios } from "../../hooks";
import { useQuery } from "react-query";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import NoRowOverlay from "../common/NoRowOverlay";
import { getDateTime } from "../../utilities/getDateTime";

const SuccessOrder = ({ handleOnSelecting }) => {
  const api = useAxios({ autoSnackbar: true });

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const { data: res, isLoading } = useQuery(
    `order-list_success_page=${page}_rowsPerPage=${pageSize}`,
    () => {
      return api.get(
        `/api/order/i/SUCCESS/p?page=${page}&rowsPerPage=${pageSize}`
      );
    }
  );

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID", minWidth: 90, flex: 0.5 },
      {
        field: "order_number",
        headerName: "Order Number",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "company_name",
        headerName: "Company Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_name",
        headerName: "Package Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_credit",
        headerName: "Package Credit",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "package_price",
        headerName: "Package Price",
        minWidth: 100,
        flex: 1,
      },
      { field: "package_tax", headerName: "Tax", minWidth: 100, flex: 1 },
      {
        field: "updated_at",
        headerName: "Updated At",
        minWidth: 100,
        flex: 1,
        valueFormatter: (params) => getDateTime(params.value),
      },
    ],
    []
  );

  return (
    <>
      <DataGrid
        columns={columns}
        rowCount={res?.data?.total ?? 0}
        rows={res?.data?.rows ?? []}
        loading={isLoading}
        pagination
        paginationMode="server"
        checkboxSelection
        onSelectionModelChange={handleOnSelecting}
        page={page}
        pageSize={pageSize}
        onPageChange={(v) => setPage(v)}
        onPageSizeChange={(v) => setPageSize(v)}
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: NoRowOverlay,
        }}
      />
    </>
  );
};

export default SuccessOrder;
